import { Button } from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { useMemo, useState } from "react";
import { FS } from "src/config/constants";
import { StepStatus, useAddAssetContext } from "src/context/monitoring/addAssetContext";
import { usePoolMonitoringContext } from "src/context/monitoring/poolMonitoringContext";
import useLowerAddressParam from "src/hooks/useLowerAddressParam";
import BaseStep from "src/view/PoolMonitoring/Overview/AssetConfigOption/components/BaseStep";
import AddAssetForm from "./AddAssetForm";

export default function FirstStep({ ...props }) {
  const { pool } = useLowerAddressParam();
  const [assetCounter, setAssetCounter] = useState(0);
  let [assetList, setAssetList] = useState({ 0: { isValid: false, data: {} } });
  const { data, fetchingDataStatus } = usePoolMonitoringContext();

  const { stepStatus, setter } = useAddAssetContext();
  const disableAll = !(stepStatus.activeStep == 0);

  const currentTokenList = useMemo(() => {
    if (fetchingDataStatus === FS.SUCCESS && data && Object.entries(data).length > 0 && pool) {
      const tokens = data[pool]?.tokens;
      if (tokens) return tokens.map((token) => token.address);
      else return [];
    }
    return [];
  }, [data, fetchingDataStatus, pool]);

  const confirmDisable = useMemo(() => {
    if (Object.values(assetList).length == 0) return true;
    else {
      const assetListObject = Object.values(assetList);
      for (const asset of assetListObject) {
        if (!asset.isValid) return true;
      }
      return false;
    }
  }, [assetList]);

  function onAddAssetClick() {
    assetList[assetCounter + 1] = { isValid: false, data: {} };
    setAssetList({ ...assetList });
    setAssetCounter(assetCounter + 1);
  }

  function onConfirmClick() {
    const assetListObject = Object.values(assetList).map((asset) => asset.data);
    setter.setAssets(assetListObject);
    setter.setStepStatus((draft) => {
      draft["activeStep"] = 1;
      draft["activeStatus"] = StepStatus.INIT;
      draft["selectedStep"] = 1;
    });
  }

  return (
    <BaseStep
      {...props}
      butProps={{
        disabled: confirmDisable || !(stepStatus.activeStep == 0 && stepStatus.activeStatus === StepStatus.INIT),
        onClick: onConfirmClick,
      }}
      startComponent={
        <Button
          startIcon={<AddCircleIcon />}
          disabled={disableAll}
          variant="outlined"
          color="primary"
          onClick={() => onAddAssetClick()}
        >
          Add Asset
        </Button>
      }
    >
      {Object.keys(assetList).map((index, realIndex) => {
        return (
          <AddAssetForm
            key={index}
            index={realIndex}
            assetId={index}
            data={assetList}
            setData={setAssetList}
            currentTokenList={currentTokenList}
          />
        );
      })}
    </BaseStep>
  );
}
